import React, { useState } from 'react';
import {
  ChakraProvider,
  VStack,
  Heading,
  IconButton,
  useColorMode,
  Input,
  HStack,
  Button,
  useMediaQuery
} from '@chakra-ui/react';
import { FaSun, FaMoon } from 'react-icons/fa';
import { v4 as uuidv4 } from 'uuid';

function App() {
  const [tasks, setTasks] = useState([]);
  const { colorMode, toggleColorMode } = useColorMode();
  const [input, setInput] = useState('');
  const [isLargerThan768] = useMediaQuery('(min-width: 768px)');

  const addTask = () => {
    if (input) {
      setTasks([...tasks, { id: uuidv4(), title: input, completed: false, isEditing: false }]);
      setInput('');
    }
  };

  const deleteTask = (id) => {
    setTasks(tasks.filter(task => task.id !== id));
  };

  const startEditing = (id) => {
    setTasks(tasks.map(task => {
      if (task.id === id) {
        return { ...task, isEditing: true };
      }
      return task;
    }));
  };

  const endEditing = (id, newTitle) => {
    setTasks(tasks.map(task => {
      if (task.id === id) {
        return { ...task, title: newTitle, isEditing: false };
      }
      return task;
    }));
  };

  const handleEditChange = (e, id) => {
    const newTitle = e.target.value;
    setTasks(tasks.map(task => {
      if (task.id === id) {
        return { ...task, title: newTitle };
      }
      return task;
    }));
  };

  return (
    <ChakraProvider>
      <VStack p={4}>
        <IconButton
          icon={colorMode === 'light' ? <FaSun /> : <FaMoon />}
          isRound='true'
          size='lg'
          alignSelf='flex-end'
          onClick={toggleColorMode}
        />
        <Heading
          mb='8'
          fontWeight='extrabold'
          size='2xl'
          bgGradient='linear(to-r, pink.500, pink.300, blue.500)'
          bgClip='text'
        >
          Todo Application
        </Heading>
        <HStack>
          <Input
            variant='filled'
            placeholder='Add a new task...'
            value={input}
            onChange={(e) => setInput(e.target.value)}
            size='md'
          />
          <Button
            onClick={addTask}
            colorScheme='pink'
            px='8'
            size='md'
            _hover={{ bg: 'pink.600' }}
            _active={{ bg: 'pink.700' }}
          >
            Add Task
          </Button>
        </HStack>
        <VStack spacing={4}>
          {tasks.map((task) => (
            <HStack key={task.id} w="full" spacing={4}>
              <Input
                variant='filled'
                value={task.title}
                onChange={(e) => handleEditChange(e, task.id)}
                isReadOnly={!task.isEditing}
                flexGrow={1}
                size='md'
                _hover={{ bg: 'blue.100' }}
                _focus={{ bg: 'blue.200' }}
              />
              {task.isEditing ? (
                <Button
                  colorScheme='green'
                  onClick={() => endEditing(task.id, task.title)}
                  size='md'
                  _hover={{ bg: 'green.600' }}
                  _active={{ bg: 'green.700' }}
                >
                  Save
                </Button>
              ) : (
                <Button
                  colorScheme='green'
                  onClick={() => startEditing(task.id)}
                  size='md'
                  _hover={{ bg: 'green.600' }}
                  _active={{ bg: 'green.700' }}
                >
                  Edit
                </Button>
              )}
              <Button
                colorScheme='red'
                onClick={() => deleteTask(task.id)}
                size='md'
                _hover={{ bg: 'red.600' }}
                _active={{ bg: 'red.700' }}
              >
                Delete
              </Button>
            </HStack>
          ))}
        </VStack>
      </VStack>
    </ChakraProvider>
  );
}

export default App;
